// extracted by mini-css-extract-plugin
module.exports = {"location":"Application_location___2USr","large":"Application_large__zfJR8"};